import { render, staticRenderFns } from "./EditLuckWheel.vue?vue&type=template&id=2519cb00&scoped=true"
import script from "./EditLuckWheel.vue?vue&type=script&lang=js"
export * from "./EditLuckWheel.vue?vue&type=script&lang=js"
import style0 from "./EditLuckWheel.vue?vue&type=style&index=0&id=2519cb00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2519cb00",
  null
  
)

export default component.exports